module.exports = __webpack_public_path__ + "04_veryshort_black.e8edd6f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_veryshort_black.png
// module id = DX0C
// module chunks = 0